import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import ImageWPlaceholder from "../../components/ImageWPlaceholder";
import { imageApi } from "../../helpers";

const Home = ({ items }) => {
  let item = items[Math.floor(items.length * Math.random())];
  let image = item.src;
  if (image !== undefined) {
    image = imageApi(image, { fixWidth: 2000 });
  }
  let content = (
    <ImageWPlaceholder
      width={image.width}
      height={image.height}
      src={image.src}
      alt={item.alt}
    />
  );

  if (item.project) {
    content = <Link to={`/${item.project}`}>{content}</Link>;
  } else if (item.link) {
    content = (
      <a href={item.link} target="_blank">
        {content}
      </a>
    );
  }
  return <Layout>{content}</Layout>;
};

export default Home;
